// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import PropTypes from 'prop-types';

import { MrText } from '@ion/components';
import { Stack } from '@metarouter-private/mr-mui';
import { isPlaybookDisabled } from '@ion/api';

import { INTEGRATION_TYPES } from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/buildTableData';

import DisabledRevisionWarning from 'app/shared/components/integrations/DisabledRevisionWarning';

import allowRowClick from './allow-row-click';

export default function RevisionCell(row) {
  const styleNames = determineStyleNames(row);
  const contents = determineContents(row);
  const textProps = {
    component: 'span',
    styleNames,
    ...allowRowClick,
  };

  const revisionText = <MrText {...textProps}>{contents}</MrText>;

  // Unmanaged rows carry no playbook, so they can never show the warning.
  const showDisabledWarning = Boolean(row.playbook) && isPlaybookDisabled(row.playbook);
  if (!showDisabledWarning) {
    return revisionText;
  }

  return (
    <Stack direction="row" spacing={0.5} alignItems="center" {...allowRowClick}>
      {revisionText}
      <DisabledRevisionWarning />
    </Stack>
  );
}

RevisionCell.propTypes = {
  row: PropTypes.object,
};

export function determineStyleNames(row) {
  const isSemiBold = row.deployedRevision && row.deployedRevision !== row.stagedRevision;
  if (isSemiBold) {
    return 'sm semiBold';
  }

  return 'sm';
}

function determineContents(row) {
  const isUnmanagedIntegration = row.type === INTEGRATION_TYPES.UNMANAGED;
  if (isUnmanagedIntegration) {
    return '-';
  }

  return `Revision ${row.stagedRevision}`;
}
